import { useInfiniteQuery } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import { ep } from "@/api/endpoints";
import { qk } from "@/api/queryKeys";
import type { PlotList } from "@/api/types";
import { usePlotViewer } from "@/features/plot/usePlot";

/** 계약 기본값(inventory 4절 플롯: 기본 20·최대 50). */
const PAGE_SIZE = 20;

/** 비회원·회원 공용. 로그인돼 있으면 토큰을 보내 tagline 의 {{user}} 가 대표 프로필 이름으로 온다 — 키는 보는 사람별(usePlotViewer, AC0-359) */
export function usePlots() {
  const viewer = usePlotViewer();
  return useInfiniteQuery({
    queryKey: qk.plots(viewer),
    queryFn: ({ pageParam }) => apiFetch<PlotList>(ep.plots({ cursor: pageParam, limit: PAGE_SIZE })),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
  });
}
